export const SAAS_LIMIT_MODAL_NAME = 'PROJECTS_SAAS_LIMIT_MODAL';
export const PROJECTS_LIMIT_MODAL_NAME = 'PROJECTS_LIMIT_MODAL';
export const NO_INVITE_IN_PRIVATE_PROJECT_MODAL_NAME = 'NO_INVITE_IN_PRIVATE_PROJECT_MODAL';
